const initialState: ReduxStoreRegister.IState = {};

export default function (state = initialState, action: ReduxStoreRegister.IAction): ReduxStoreRegister.IState {
    return state;
}
